// Utility function to convert numbers to string with comma separated values if necessary
// I.E. 10000 -> "10,000"
export default function formatNumber(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
